export const billingPathForSurface = (adminSurface: boolean): string | null => adminSurface ? '/billing' : null;

